<template>
  <v-card flat>
    <v-img :src="photo.image" :aspect-ratio="16 / 9" class="white--text with-scrim">
      <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
        <v-progress-circular indeterminate />
      </v-layout>
      <div class="px-2" style="position: absolute; width: 100%; bottom: 1rem;">{{ photo.caption }}</div>
    </v-img>
    <can I="edit" a="Organization">
      <v-menu v-model="editing" left min-width="300" :close-on-content-click="false">
        <v-btn slot="activator" class="mt-4" color="primary" small fab absolute top right>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-card>
          <v-card-text>
            <v-text-field label="Caption" v-model="caption" />
          </v-card-text>
          <v-card-actions>
            <v-btn flat @click="cancel" color="grey">Cancel</v-btn>
            <v-btn @click="save" :disabled="!photo.image" color="primary">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-btn small fab absolute top right @click="$emit('remove')" class="mt-4 mr-5" color="error">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </can>
  </v-card>
</template>

<script>
export default {
  props: {
    organization: { type: Object, required: true },
    photo: { type: Object, required: true },
  },

  data() {
    return {
      editing: false,
      caption: this.photo.caption,
    }
  },

  methods: {
    cancel() {
      this.editing = false
      this.caption = this.photo.caption
    },

    save() {
      this.$store
        .dispatch('admin/organizations/editPhoto', {
          organization: { id: this.organization.id },
          photo: { id: this.photo.id, caption: this.caption },
        })
        .then(this.cancel)
    },
  },
}
</script>
